import React from "react";
import "./index.css";
import { cardsData } from "../../utils/data";
import Card from "../card/index";

function Cards() {
  return (
    <div className="cards-container">
      {cardsData.map((card, id) => {
        return (
          <div className="card-item-container" key={card.id}>
            <Card
              title={card.title}
              color={card.color}
              barValue={card.barValue}
              value={card.value}
              png={card.png}
              series={card.series}
            />
          </div>
        );
      })}
    </div>
  );
}

export default Cards;
